<template>
  <div class="index">
<!--     <div class="index_banner">
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../../static/images/banner.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="../../static/images/banner.jpg" alt="">
            </div>
        </div>
        如果需要分页器
        <div class="swiper-pagination"></div>
        
        如果需要导航按钮
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
        
        如果需要滚动条
        <div class="swiper-scrollbar"></div>
  </div>
</div> -->
    <div class="common_wrap">
      <p class="common_title">热门品类</p>
      <div class="index_items clearfix">
        
        <div class="index_item" v-for='item in Category'>
          <router-link :to='"/product/list/"+item.id'>
            <div>
              <img :src="domain+item.icon1" v-if='item.icon1'>
            </div>
            <p>{{item.name}}</p>
          </router-link>
        </div>
      </div>
    </div>

    <div class="hot_wrap">
      <div class="common_wrap">
        <p class="common_title">热门单品</p>
        <div class="hotlist clearfix">
          
            <div class="hot_item" v-for='item in hots'>
              <router-link :to='"/product/detail/"+item.id'>
              <div class="hotimg_wrap">
                <img src="../../static/images/new.png" class="tips" v-if='item.flag==1'>
                <img src="../../static/images/hot.png" class="tips" v-if='item.flag==2'>
                <img :src="domain+item.litpic" class="p">
              </div>
              <p class="p_name">{{item.title}}</p>
              <p class="p_name_e">{{item.model}}</p>
              </router-link>
            </div>
         
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      Category:[],
      hots:[],
      domain:''
    }
  },
  watch:{
    '$route':function(to,from){
      this.getCategory();
    this.getHot()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getCategory();
    this.getHot()
  },
  methods:{
    getCategory:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        limit:10,
        cid:19,
        status:1
      }))
      .then(response => {
        console.log(response);
        this.Category=response.data.data
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    getHot:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_hot', this.$qs.stringify({

      }))
      .then(response => {
        console.log(response);
        this.hots=response.data.data
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>

 .index_items{
  width: 1200px;
  margin: 0 auto;
 }
 .index_item{
  width: 100px;
  float: left;
  text-align: center;
  margin-left: 175px;
  position: relative;
  margin-bottom: 90px;
 }
 .index_item:first-child{
  margin-left: 0;
 }
 .index_item:nth-child(6n){
  margin-left: 0;
 }
 .index_item a>div{
  height: 60px;
  position: relative;
  margin-bottom: 20px;
 }
 .index_item img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
 }
 .index_item p{
  font-size: 18px;
  color: #383838;
 }
 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .common_title{
  font-size: 20px;
  color: #383838;
  text-align: center;
  margin-bottom: 50px;
  padding-top: 60px;
 }
 .common_title:before{
  content: '';
  display: inline-block;
  width: 22px;
  height: 1px;
  background-color: #7e7e7e;
  position: relative;
  top: -6px;
  right: 7px;
 }
 .common_title:after{
  content: '';
  display: inline-block;
  width: 22px;
  height: 1px;
  background-color: #7e7e7e;
  position: relative;
  top: -6px;
  left: 7px;
 }
 .index_active{
  min-width: 1300px;
 }
 .index_active img{
  width: 100%;
 }
 .hot_item{
  width: 290px;
  height: 382px;
  background-color: #fff;
  float: left;
  margin-right: 13px;
  border-radius: 4px;
  margin-bottom: 39px;
 }
 .hot_item:hover{
  position: relative;
  box-shadow: 2px 2px 20px #e4e4e4;
  top: -10px
 }
 .hot_item:nth-child(4n){
  margin-right: 0;
 }
 .hot_wrap{
  background-color: #f8f7f7;
  min-width: 1200px;
  margin: 0 auto;
 }
 .hotimg_wrap{
  height: 250px;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
 }
 .hotimg_wrap img.p{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
 }
 .hotimg_wrap .tips{
  top: 22px;
  left: 14px;
  position: absolute;
  z-index: 999
 }
 .hot_item p{
  font-size: 18px;
  color: #5d5d5d;
  padding-left: 27px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
 }
 .p_name{
  margin-bottom: 16px;
 }
</style>


// WEBPACK FOOTER //
// src/components/product.vue